enum HighlightKey {
  AccidentFree = 'AccidentFree',
  GreatDeal = 'KeepMovingPrice',
  PriceDrop = 'RecentPriceDrop',
  RecentlyAdded = 'RecentlyAdded'
}

export default HighlightKey;
